import React, { useState } from "react";
import { Link} from 'react-router-dom';
import {
  Button,
  Form,
  Alert,
  Input,

  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
  Modal,
  ModalBody
} from "reactstrap";
import API from "api.js";
import Header from "components/Frontend/Header";
import Footer from "components/Frontend/Footer";
import "assets/css/business-page.css"

export default function BusinessPage(props) {

	const [instituteForm, setInstituteForm] = useState(false);

	const showHideInstituteRequestForm = (status) => {
		setInstituteForm(status);
	}

	return (
		<React.Fragment>
			<Header />
			<div className="innerPage">
				<div className="hero-section business-hero mt-80">
					<div className="container">
						<div className="row align-items-center">
						<div className="col-lg-8 col-md-8">
							<div className="hero-content">
							<h1 className="primary-heading mfw-600">
							Empower your <br className="d-none d-lg-block" /> institute with us!
							</h1>
							<h3 className="text-center text-md-start">AI powered portal to help <br className="d-none d-lg-block" /> boost your Students’ PTE Scores</h3>
							<p className="sub-heading bold-sub-heading">
							Over 300+ Institutes have joined us to Increase <br className="d-none d-lg-block" /> their Accuracy and got fast results.
							</p>
							<div className="text-center text-md-start">
								<Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
							</div>
							</div>
						</div>
						<div className="col-lg-4 col-md-4">
							<div className="hero-img-wrapper">
							<img
								className="img-fluid"
								src="/images/web-new-images/bannerImg.png"
								alt="LA"
							/>
							</div>
						</div>
						</div>
					</div>
				</div>
				<div className="why-choosing-section business-why-choosing">
					<div className="container">
						<div className="row">
						<div className="white-bg-features feature-cards mt-0">
							<div className="feature-card mint-green-card">
								<div className="rounded-circle">
									<div className="img-wrapper">
										<img
										src="/images/web-new-images/icons/11.svg"
										alt="LA"
										/>
									</div>
								</div>
								<h3>Real-Time Test Environment</h3>							
							</div>
							<div className="feature-card blue-card">
								<div className="rounded-circle">
									<div className="img-wrapper">
										<img
										src="/images/web-new-images/icons/22.svg"
										alt="LA"
										/>
									</div>
								</div>
								<h3>Detailed <br /> Analytics</h3>							
							</div>
							<div className="feature-card greenish-yellow-card">
								<div className="rounded-circle">
									<div className="img-wrapper">
										<img
										src="/images/web-new-images/icons/a-green.svg"
										alt="LA"
										/>
									</div>
								</div>
								<h3>Instant and Accurate <br /> Evaluation</h3>							
							</div>
							<div className="feature-card purple-card">
								<div className="rounded-circle">
									<div className="img-wrapper">
										<img
										src="/images/web-new-images/icons/a-icon.svg"
										alt="LA"
										/>
									</div>
								</div>
								<h3>Mock <br /> Tests</h3>							
							</div>
							<div className="feature-card light-apricot-card">
								<div className="rounded-circle">
									<div className="img-wrapper">
										<img
										src="/images/web-new-images/icons/a-red.svg"
										alt="LA"
										/>
									</div>
								</div>
								<h3>In-Depth <br /> Feedback</h3>							
							</div>
							<div className="feature-card mint-green-card">
								<div className="rounded-circle">
									<div className="img-wrapper">
										<img
										src="/images/web-new-images/icons/11.svg"
										alt="LA"
										/>
									</div>
								</div>
								<h3>Templates</h3>							
							</div>
						</div>
						<div className="text-center bottom-btn-wrapper">
							<p className="sub-heading ">
							Empower your institute with us!
							</p>
							<Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
						</div>
						</div>
					</div>
				</div>
				<div className="af-section tasks-section">
					<div className="container">
						<div className="row">
						<div className="col-lg-12">
							<h2 className="primary-heading text-center">
							Now conduct tasks <br className="d-block" /> <span className="wpl-badge pte-naati-badge text-white">seamlessly with us</span>
							</h2>
							<div className="af-content">							
							<ul className="af-lists af-lists-col-1">						
								<li className="af-list-outer">
								<div className="af-list">
									<p>
									15,000+ <span>Questions</span>
									</p>
									<div className="img-wrapper">
									<img
										className="img-fluid"
										src="/images/web-new-images//icons/feature-icon1.svg"
										alt="LA"
									/>
									</div>
								</div>
								</li>
								<li className="af-list-outer">
								<div className="af-list">
									<p>
									AI Scoring <span>For all modules</span>
									</p>
									<div className="img-wrapper">
									<img
										className="img-fluid"
										src="/images/web-new-images//icons/feature-icon1.svg"
										alt="LA"
									/>
									</div>
								</div>
								</li>
							</ul>
							<div className="af-lists-img">
								<img
								className="img-fluid"
								src="/images/web-new-images/task-img1.png"
								alt="LA"
								/>
							</div>
							<ul className="af-lists af-lists-col-3">					
								<li className="af-list-outer">
								<div className="af-list">
									<p>
										<p>12+ Countries <br className="d-none d-md-block" /> Use</p>
										{/* <div className="flag-wrapper-outer">
											<div className="flag-wrapper">
												<img className="img-fluid" src="/images/web-new-images/flags-img.png" alt="LA"/>
											</div>
										</div> */}
										{/* <div className="flag-wrapper-outer"> */}
											<div className="flag-wrapper">
												<img className="img-fluid" src="/images/web-new-images/flags-img-01.png" alt="LA"/>
											</div>
										{/* </div> */}
									</p>
									<div className="img-wrapper">
									<img
										className="img-fluid"
										src="/images/web-new-images//icons/feature-icon1.svg"
										alt="LA"
									/>
									</div>
								</div>
								</li>
								<li className="af-list-outer">
								<div className="af-list">
									<p>
									Unlimited <span>Mock Test</span>
									</p>
									<div className="img-wrapper">
									<img
										className="img-fluid"
										src="/images/web-new-images//icons/feature-icon1.svg"
										alt="LA"
									/>
									</div>
								</div>
								</li>
							</ul>
								<div className="text-center af-content-btn">
								<Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
								</div>
							</div>
						</div>
						</div>
					</div>
				</div>
				<div className="student-score-section">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">							
								<h2 className="primary-heading text-center">
								How we help your student <br className="d-none d-md-block" /> <span className="wpl-badge text-white">perfect their score?</span>
								</h2>
								<div className="sub-heading-outer">
									<p className="sub-heading text-white text-left">
										Every PTE aspirant has some goal in their mind. Our site is a curation of several questions by the leading experts. You get a brilliant UI where each section is divided strategically, so students quickly find what they are looking for. The Portal Is designed to power your students’ preparation with new-age Artificial Intelligence.
										<br />
										<br />
										Built on PTE standard algorithms. The technology is quick. Within just a few seconds, evaluates your students’ response and gives the orrections, imitating a human-like response, but only quicker and more accurately. The 95% algorithm adoption from the PTE exam ensures that your student gets just 5% more or less marks and score almost as expected.
									</p>
								</div>
								<div className="ss-cards">							
									<div className="ss-card-outer">
										<div className="ss-card">
											<img
											className="img-fluid ss-card-img"
											src="/images/web-new-images/instImg.png"
											alt="LA"
											/>
										</div>
									</div>
									<div className="ss-card-outer">
										<div className="ss-card">
											<ul className="p-0 position-relative">
												{/* <img
												className="img-fluid emoji-img"
												src="/images/web-new-images/emojis/3.png"
												alt="LA"
												/> */}
												<li className="tick-list-item">
													<h3 className="m-0 text-white">
													<img
														src="/images/web-new-images/icons/check-icon.svg"
														alt="LA"
													/>{" "}
													Unlimited questions
													</h3>
												</li>   
												<li className="tick-list-item">
													<h3 className="m-0 text-white">
													<img
														src="/images/web-new-images/icons/check-icon.svg"
														alt="LA"
													/>{" "}
													Unlimited mock tests
													</h3>
												</li>   
												<li className="tick-list-item">
													<h3 className="m-0 text-white">
													<img
														src="/images/web-new-images/icons/check-icon.svg"
														alt="LA"
													/>{" "}
													Access templates
													</h3>
												</li>   
												<li className="tick-list-item">
													<h3 className="m-0 text-white">
													<img
														src="/images/web-new-images/icons/check-icon.svg"
														alt="LA"
													/>{" "}
													Accurate the score card
													</h3>
												</li>   
												<li className="tick-list-item">
													<h3 className="m-0 text-white">
													<img
														src="/images/web-new-images/icons/check-icon.svg"
														alt="LA"
													/>{" "}
													In-Depth feedback
													</h3>
												</li>   
												<li className="tick-list-item">
													<h3 className="m-0 text-white">
													<img
														src="/images/web-new-images/icons/check-icon.svg"
														alt="LA"
													/>{" "}
													Success Plan
													</h3>
												</li>   
												<li className="tick-list-item">
													<h3 className="m-0 text-white">
													<img
														src="/images/web-new-images/icons/check-icon.svg"
														alt="LA"
													/>{" "}
													Progress tracking
													</h3>
												</li>   
												<li className="tick-list-item">
													<h3 className="m-0 text-white">
													<img
														src="/images/web-new-images/icons/check-icon.svg"
														alt="LA"
													/>{" "}
													Instant results
													</h3>
												</li>   
												<li className="tick-list-item">
													<h3 className="m-0 text-white">
													<img
														src="/images/web-new-images/icons/check-icon.svg"
														alt="LA"
													/>{" "}
													Real time performance
													</h3>
												</li>   
												<li className="tick-list-item">
													<h3 className="m-0 text-white">
													<img
														src="/images/web-new-images/icons/check-icon.svg"
														alt="LA"
													/>{" "}
													& Much more
													</h3>
												</li>
											</ul>
											<div className="text-center">
												<Link to="/auth/register" className="primary-btn dark-border">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
											</div>
										</div>
									</div>								
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="faq-section">
					<div className="container">
						<div className="row">
						<h2 className="secondary-heading text-center">
							Frequently Asked Questions
						</h2>

						<div className="accordion" id="accordionExample">
							<div className="accordion-item">
							<h2 className="accordion-header" id="headingOne">
								<button
								className="accordion-button"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#collapseOne"
								aria-expanded="true"
								aria-controls="collapseOne"
								>
								What is the recommended number of PTE mock tests that I should undertake?
								</button>
							</h2>
							<div
								id="collapseOne"
								className="accordion-collapse collapse show"
								aria-labelledby="headingOne"
								data-bs-parent="#accordionExample"
							>
								<div className="accordion-body">
								It is recommended to take three complete PTE mock tests.
								</div>
							</div>
							</div>
							<div className="accordion-item">
							<h2 className="accordion-header" id="headingTwo">
								<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#collapseTwo"
								aria-expanded="false"
								aria-controls="collapseTwo"
								>
								What is the PTE requirement for canada?
								</button>
							</h2>
							<div
								id="collapseTwo"
								className="accordion-collapse collapse"
								aria-labelledby="headingTwo"
								data-bs-parent="#accordionExample"
							>
								<div className="accordion-body">
								The minimum PTE score for Bachelor's programs, Advanced Diplomas, and Post Graduate Programs is 60, with a minimum band score of 53. Students with an overall score of 56 and each band score of at least 51 have also been granted study permits.
								</div>
							</div>
							</div>
							<div className="accordion-item">
							<h2 className="accordion-header" id="headingThree">
								<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#collapseThree"
								aria-expanded="false"
								aria-controls="collapseThree"
								>
								What is the duration of a full-length PTE mock test?
								</button>
							</h2>
							<div
								id="collapseThree"
								className="accordion-collapse collapse"
								aria-labelledby="headingThree"
								data-bs-parent="#accordionExample"
							>
								<div className="accordion-body">
								Around 2 hours. Students can attempt the test in one go or by taking short breaks.
								</div>
							</div>
							</div>
						</div>
						</div>
					</div>
				</div>				
			</div>
			<Footer />
			<InstituteForm instituteForm={instituteForm} closeForm={showHideInstituteRequestForm} />
		</React.Fragment>
	);
}


const InstituteForm = ({ instituteForm, closeForm }) => {

	const [taskName, setTaskName] = useState("");
	const [taskPhone, setTaskPhone] = useState("");
	const [taskEmail, setTaskEmail] = useState("");
	const [taskInstitute, setTaskInstitute] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [successMessage, setSuccessMessage] = useState("");

	const updateMessages = (type, message) => {
		switch(type) {
			case "error":
				setSuccessMessage("");
				setErrorMessage(message);
				break;
			case "success":
				setErrorMessage("");
				setSuccessMessage(message);
				break;
		}
	}

	const post20taskRequest = async (e) => {
		e.preventDefault();
		if(taskName === '' || taskPhone === '' || taskEmail === '' || taskInstitute === '') {
			updateMessages("error", "Please fill all fields!");
		} else {
			const bodyFormData = new FormData();
			bodyFormData.set('name', taskName);
			bodyFormData.set('phone', taskPhone);
			bodyFormData.set('email', taskEmail);
			bodyFormData.set('institute', taskInstitute);
			
			let res = null;
			try {
				res = await API({
					method: 'POST',
					url: '/task-request-submit-data',
					data: bodyFormData
				});
			} catch(error) {};

			if (res.status === 200) {
				updateMessages("success", "Request Submitted Successfully!");
				setTimeout(function() {
					window.location.reload();
				}, 2000);
			} else {
				updateMessages("error", "Unable to submit request!");
			}
		}
	}

	return (
		<Modal isOpen={instituteForm} id="anouncementPopup" size="lg" className="taskpopup">
			<ModalBody>
				<Container>
					<Row>
						<Col className="ml-auto mr-auto" lg="12" md="12">
							<button onClick={ (e) => { closeForm(false) }} type="button" className="close" data-dismiss="modal">&times;</button>
							<div className="mobileIcon">
								<img src="/images/experienced-trainer.png" alt="mobile-img" />
							</div>
							<Form action="" className="form" method="">
								<h3 className="header text-center">Get our portal for your institute</h3>
								
								{successMessage !== "" && 
									<Alert color="success">{successMessage}</Alert>
								}
								{errorMessage !== "" && 
									<Alert color="danger">{errorMessage}</Alert>
								}

								<InputGroup>
									<InputGroupText>
										<i className="nc-icon nc-single-02" />
									</InputGroupText>
									<Input
										placeholder="Name"
										type="text"
										name="task_name"
										value={taskName}
										onChange={(e) => { setTaskName(e.target.value)} }
										autoComplete="off"
									/>
								</InputGroup>
								<InputGroup>
									<InputGroupText>
										<i className="nc-icon nc-mobile" />
									</InputGroupText>
									<Input
										placeholder="Phone"
										type="number"
										name="task_phone"
										value={taskPhone}
										onChange={(e) => { setTaskPhone(e.target.value)} }
										autoComplete="off"
									/>
								</InputGroup>
								<InputGroup>
									<InputGroupText>
										<i className="nc-icon nc-email-85" />
									</InputGroupText>
									<Input
										placeholder="Email"
										type="text"
										name="task_email"
										value={taskEmail}
										onChange={(e) => { setTaskEmail(e.target.value)} }
										autoComplete="off"
									/>
								</InputGroup>
								<InputGroup>
									<InputGroupText>
										<i className="nc-icon nc-badge" />
									</InputGroupText>
									<Input
										placeholder="Institute Name"
										type="text"
										name="task_institute"
										value={taskInstitute}
										onChange={(e) => { setTaskInstitute(e.target.value)} }
										autoComplete="off"
									/>
								</InputGroup>
								<br />
								<Button
									className="btn-round mb-3"
									color="warning"
									onClick={(e) => { post20taskRequest(e) }}
								>Submit</Button>
							</Form>
						</Col>
					</Row>
				</Container>
			</ModalBody>
		</Modal>
	);
}